import React from "react";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import ReactHtmlParser from "react-html-parser";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faYoutube,
  faFacebook,
  faTwitter,
  faInstagram
} from "@fortawesome/free-brands-svg-icons";

const TipsDetail = props => {
  console.log(props);
  const { tip } = props;
  if (tip) {
    return (
      <div className="container section project-details">
        <div className="card z-depth-0">
          <div className="card-content">
            <span className="card-title">{tip.title}</span>
            <div className="left-align"> {ReactHtmlParser(tip.content)}</div>
          </div>
          <div className="card-action grey lighten-4 grey-text">
            <div>Tác Giả : {tip.authorFullName}</div>
            <div>
              <div className="social-container">
                <h3>@Mọi ý kiến vui lòng</h3>
                <a
                  href="https://www.youtube.com/stone1803"
                  className="youtube social"
                >
                  <FontAwesomeIcon icon={faYoutube} size="2x" />
                </a>
                <a
                  href="https://www.facebook.com/phucbun"
                  className="facebook social"
                >
                  <FontAwesomeIcon icon={faFacebook} size="2x" />
                </a>
                <a
                  href="https://www.twitter.com/VoNhaiTu"
                  className="twitter social"
                >
                  <FontAwesomeIcon icon={faTwitter} size="2x" />
                </a>
                <a
                  href="https://www.instagram.com/phuc1109"
                  className="instagram social"
                >
                  <FontAwesomeIcon icon={faInstagram} size="2x" />
                </a>
              </div>
              <div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="container center">
        <p>Loading----------------Loading</p>
      </div>
    );
  }
};

const mapStateToProps = (state, ownProps) => {
  console.log(state);
  const id = ownProps.match.params.id;
  const tips = state.firestoreReducer.data.tips;
  const tip = tips ? tips[id] : null;
  return {
    tip: tip
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect([
    {
      collection: "tips"
    }
  ])
)(TipsDetail);
